import { render, staticRenderFns } from "./rolePermission.vue?vue&type=template&id=51224a5c&scoped=true&"
import script from "./rolePermission.vue?vue&type=script&lang=js&"
export * from "./rolePermission.vue?vue&type=script&lang=js&"
import style0 from "./rolePermission.vue?vue&type=style&index=0&id=51224a5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51224a5c",
  null
  
)

export default component.exports